import { Injectable } from '@angular/core';
import { Topics } from '@common/interfaces/topics';
import { Store, StoreConfig } from '@datorama/akita';
import { LastUpdate } from './lastUpdate.model';

export interface LastUpdateState extends LastUpdate {};

function createInitialState(): LastUpdateState {
  return {
    [Topics.USERS]: null,
    [Topics.PROJECTS]: null,
    [Topics.WORKFLOWS]: null,
    [Topics.ISSUE_STATES]: null,
    [Topics.ISSUE_STATE_WORKFLOWS]: null,
    [Topics.ISSUE_TYPES]: null,
    [Topics.ISSUE_TYPE_INTERFACES]: null,
    [Topics.ISSUE_TYPE_WORKFLOWS]: null,
   }
}

@Injectable({ providedIn: 'root' })
@StoreConfig({
  name: 'lastUpdate'
})
export class LastUpdateStore extends Store<LastUpdateState> {
  constructor() {
    super(createInitialState());
  }
}
